(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-upsell')) {
    customElements.define(
      'bb-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', (event) => {
            if (event.target.matches('input[type="radio"]')) this.apply(event.target);
          });
          const checked = this.querySelector('input[type="radio"]:checked');
          if (checked) this.apply(checked);
        }

        apply(input) {
          const price = input.dataset.price;
          document.querySelectorAll('form.bb-buy:not(.bb-buy--fixed)').forEach((form) => {
            const id = form.querySelector('input[name="id"]');
            if (id) id.value = input.value;
            form.querySelectorAll('[data-bb-btn-price]').forEach((el) => (el.textContent = price));
          });
          document.querySelectorAll('[data-bb-sticky-price]').forEach((el) => (el.textContent = price));
          document.querySelectorAll('[data-bb-sticky-title]').forEach((el) => {
            el.textContent = input.dataset.title || el.dataset.base || el.textContent;
          });
          document.querySelectorAll('[data-bb-sticky-sub]').forEach((el) => {
            el.textContent = input.dataset.sub || el.dataset.base || el.textContent;
          });
          document.querySelectorAll('bb-upsell input[type="radio"]').forEach((radio) => {
            if (radio.value === input.value && !radio.checked) radio.checked = true;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
